module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', {
    staticClass: "f2 lh-copy mt4"
  }, [_vm._v("Account Settings")]), _vm._v(" "), _c('div', {
    staticClass: "mv4"
  }, _vm._l((this.$store.state.messages), function(message, index) {
    return _c('ak-alert', {
      key: index,
      attrs: {
        "color": message.color,
        "deleteable": message.deleteable
      },
      on: {
        "close": function($event) {
          return _vm.clearMessage(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(message.text))])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row-l flex-column justify-between",
    attrs: {
      "id": "personalInfo"
    }
  }, [_c('div', {
    staticClass: "flex flex-column justify-between items-start pa4 bg-white shadow-card br1 w-50-l w-100 mr3-l mr0"
  }, [_c('div', [_c('h2', {
    staticClass: "f3 mb3"
  }, [_vm._v("Your Referral Code")]), _vm._v(" "), _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n          My code: "), _c('strong', [_vm._v(_vm._s(_vm.user.referral_code))])]), _vm._v(" "), _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n          Share AKKO with your friends and family to receive credit towards future claims!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_c('strong', [_vm._v("Total Deductible Credit Balance:")]), _vm._v("\n          $" + _vm._s(this.$store.state.user.total_deductible_credit.toFixed(2)) + "\n        ")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "dib-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showShareReferralCodeModal = true
      }
    }
  }, [_vm._v("Share referral code")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pa4 bg-white shadow-card br1 w-50-l w-100 ml3-l ml0 mt3 mt0-l"
  }, [_c('h2', {
    staticClass: "f3 mb3"
  }, [_vm._v("Your Personal Info")]), _vm._v(" "), _c('div', {
    staticClass: "mv4",
    class: [!this.isMobile && 'justify-between flex']
  }, [_c('div', [_c('div', {
    staticClass: "mb4 mt2"
  }, [_c('div', {
    staticClass: "silver mb2"
  }, [_vm._v("Name - "), _c('span', {
    staticClass: "color-theme pointer",
    on: {
      "click": function($event) {
        _vm.showNameModal = true
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_vm._v(_vm._s(((this.user.first_name) + " " + (this.user.last_name))))])]), _vm._v(" "), _c('div', {
    staticClass: "mb4 mt2"
  }, [_c('div', {
    staticClass: "silver mb2"
  }, [_vm._v(_vm._s(this.user.has_active_claims ? 'Phone' : 'Phone - ')), (!_vm.user.has_active_claims) ? _c('span', {
    staticClass: "color-theme pointer",
    on: {
      "click": function($event) {
        _vm.showPhoneModal = true
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_vm._v(_vm._s(this.formattedPhone))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "mb4 mt2"
  }, [_c('div', {
    staticClass: "silver mb2"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "black"
  }, [_vm._v(_vm._s(this.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "mb4 mt2"
  }, [_c('div', {
    staticClass: "silver mb2"
  }, [_vm._v("Address")]), _vm._v(" "), (_vm.user.address) ? _c('div', {
    staticClass: "black"
  }, [_vm._v(_vm._s(this.user.street) + ", " + _vm._s(this.user.apt) + " "), _c('br'), _vm._v("\n              " + _vm._s(this.user.city) + ", " + _vm._s(this.user.state) + " " + _vm._s(this.user.zip) + "\n            ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "dib-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showPasswordModal = true
      }
    }
  }, [_vm._v("Update password")])], 1)])]), _vm._v(" "), _c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v("Your Plans")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    attrs: {
      "id": "yourPlans"
    }
  }, [_c('div', {
    staticClass: "pa4 bg-white shadow-card br1 w-50-l w-100"
  }, [_c('h2', {
    staticClass: "f3 mb3"
  }, [_vm._v("Primary")]), _vm._v(" "), _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n        " + _vm._s(_vm.coveragePlanFirstLine) + "\n        "), _vm._v(" "), _c('br'), _vm._v(" "), (this.user.payment_processor !== 'PARTNER') ? _c('div', [_vm._v("Plan cost: "), _c('strong', [_vm._v("$" + _vm._s(_vm.discount_amount))]), _vm._v(" "), (this.user.related_users && this.user.related_users.length > 0) ? _c('div', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Other Plans:")]), _vm._v(" "), _vm._l((_vm.otherPlans), function(ref, index) {
    var user = ref.user;
    var plan = ref.plan;
    var planType = ref.planType;
    var discountAmount = ref.discountAmount;
    var phone = ref.phone;
    var itemCovered = ref.itemCovered;

    return _c('div', {
      key: index
    }, [_c('strong', [_vm._v(_vm._s(plan))]), _vm._v(" "), (user !== '') ? _c('br') : _vm._e(), _vm._v("\n              " + _vm._s(user) + "\n\n              "), _c('br'), _vm._v("\n              Plan cost: "), _c('strong', [_vm._v("$" + _vm._s(discountAmount))]), _vm._v(" "), _c('br'), _vm._v(" "), (itemCovered !== 'PHONE') ? _c('div', [_vm._v("\n                Plan type: "), _c('strong', [_vm._v(_vm._s(planType))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v("\n\n              Phone: "), _c('strong', [_vm._v(_vm._s(phone))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
  })], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n          View protection terms and details "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "https://getakko.com/legal",
      "rel": "noopener noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(".\n          "), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.user.user_id === _vm.user.primary_account_holder.id && _vm.user.payment_processor !== 'PARTNER') ? _c('div', {
    staticClass: "justify-content"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/edit-coverage"
    }
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    }
  }, [_vm._v("Change plan")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/add-plan"
    }
  }, [_c('ak-button', {
    attrs: {
      "disabled": !this.user.is_activated,
      "block": "",
      "secondary": ""
    }
  }, [_vm._v("Add Plan")])], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.secondCoverage) ? _c('div', {
    staticClass: "pa4 bg-white shadow-card br1"
  }, [_c('h2', {
    staticClass: "f3 mb3"
  }, [_vm._v("Addon 1")]), _vm._v(" "), _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n        Current plan: " + _vm._s(_vm.secondCoverage.name) + "\n        "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.thirdCoverage) ? _c('div', {
    staticClass: "pa4 bg-white shadow-card br1"
  }, [_c('h2', {
    staticClass: "f3 mb3"
  }, [_vm._v("Addon 2")]), _vm._v(" "), _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n        Current plan: " + _vm._s(_vm.thirdCoverage.name) + "\n        "), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('h1', {
    staticClass: "f2 lh-copy pt3",
    attrs: {
      "id": "billing"
    }
  }, [_vm._v("Billing")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row-l flex-column",
    attrs: {
      "id": "billingInfo"
    }
  }, [_c('div', {
    staticClass: "pa4 bg-white shadow-card br1 flex flex-column justify-between items-start w-50-l w-100 mr3-l mr0"
  }, [_c('h2', {
    staticClass: "f3"
  }, [_vm._v("Your Billing Info")]), _vm._v(" "), (_vm.user.payment_processor === 'PARTNER') ? _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_c('div', {
    staticClass: "lh-copy"
  }, [_vm._v("\n          Your billing is managed by one of our trusted partners. Please sign in to your account through their\n          platform or contact them directly for billing details.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "lh-copy",
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.partner_property.name) + "\n          " + _vm._s(_vm.user.partner_property.website) + "\n          " + _vm._s(_vm.user.partner_property.phone_no) + "\n          " + _vm._s(_vm.user.partner_property.email) + "\n        ")])]) : (_vm.user.credit_card_brand && _vm.user.credit_card_last4) ? _c('div', [_c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n          Current card: "), _c('strong', [_vm._v(_vm._s(_vm.user.credit_card_brand) + " x" + _vm._s(_vm.user.credit_card_last4))])]), _vm._v(" "), _c('div', {
    staticClass: "dib-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showCreditCardModal = true
      }
    }
  }, [_vm._v("Update credit card")])], 1)]) : _c('div', [_vm._v("\n        If you'd like to update your payment method, please email "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com",
      "rel": "noopener noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("billing@getakko.com")]), _vm._v(".\n      ")])]), _vm._v(" "), (_vm.user.invoice_information) ? _c('div', {
    staticClass: "pa4 bg-white shadow-card br1 flex flex-column justify-between items-start w-50-l w-100 ml3-l ml0 mt3 mt0-l",
    attrs: {
      "id": "payments"
    }
  }, [_c('h2', {
    staticClass: "f3 mb3"
  }, [_vm._v("Payments")]), _vm._v(" "), (_vm.user.primary_account_holder.id == _vm.user.user_id) ? _c('div', {
    staticClass: "flex flex-column justify-between items-start"
  }, [_c('label', {
    staticClass: "f5 fw5 db mb3",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v(_vm._s(_vm.nextInvoiceData(_vm.user.invoice_information.upcoming_invoices)))]), _vm._v(" "), _vm._l((_vm.user.invoice_information.all_invoices.slice(0, 3)), function(invoice, index) {
    return _c('div', {
      key: index,
      staticClass: "mb3"
    }, [_vm._v("\n          " + _vm._s(_vm.invoiceData(invoice)) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt2 lh-copy"
  }, [_vm._v("\n          Account Status: "), _c('strong', [_vm._v(_vm._s(_vm.subscription_status))])]), _vm._v(" "), (_vm.user.invoice_information.invoice_url && _vm.user.primary_account_holder.id == _vm.user.user_id) ? _c('div', {
    staticClass: "dib-ns"
  }, [_c('a', {
    staticClass: "no-underline",
    attrs: {
      "href": _vm.user.invoice_information.invoice_url,
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    }
  }, [_vm._v("Pay My Bill")])], 1)]) : _c('div', [_c('router-link', {
    staticClass: "no-underline",
    attrs: {
      "to": "/invoices"
    }
  }, [_c('ak-button', {
    staticClass: "mt4",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showCreditCardModal = true
      }
    }
  }, [_vm._v("See more")])], 1)], 1)], 2) : _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n        Your plan is paid for by: "), _c('strong', [_vm._v(_vm._s(_vm.user.primary_account_holder.first_name) + "\n        " + _vm._s(_vm.user.primary_account_holder.last_name))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb4 mw5-ns mh4"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logOut.apply(null, arguments)
      }
    }
  }, [_vm._v("Log Out")])], 1), _vm._v(" "), (_vm.showNameModal) ? _c('ak-modal', {
    attrs: {
      "title": "Edit your name"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('form', {
    staticClass: "flex-ns flex-wrap",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("New First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first_name),
      expression: "first_name"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "first_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v("New Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.last_name),
      expression: "last_name"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "last_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "disabled": !_vm.canUpdateName,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateName.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showSchoolModal) ? _c('ak-modal', {
    attrs: {
      "title": "Edit your academic info"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('form', {
    staticClass: "flex-ns flex-wrap",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt4 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "school"
    }
  }, [_vm._v("School")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "school",
      "type": "text"
    },
    domProps: {
      "value": (_vm.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.school = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "year"
    }
  }, [_vm._v("Year")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.year),
      expression: "year"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "year"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("First Year")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Second Year")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Third Year")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Fourth Year")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("Fifth Year")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "disabled": !_vm.canUpdateSchool,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateSchool.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showPhoneModal) ? _c('ak-modal', {
    attrs: {
      "title": "Edit your phone number"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('form', {
    staticClass: "flex-ns flex-wrap",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt4 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("New Phone Number")]), _vm._v(" "), _c('InputMask', {
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "phone",
      "mask": "(999) 999-9999",
      "type": "tel"
    },
    model: {
      value: (_vm.phone_no),
      callback: function($$v) {
        _vm.phone_no = $$v
      },
      expression: "phone_no"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneErrorMessage),
      expression: "phoneErrorMessage"
    }],
    staticClass: "f6 red mh3-ns",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.phoneErrorMessage) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "disabled": !_vm.canUpdatePhone,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatePhone.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showPhoneVerificationModal) ? _c('ak-modal', {
    attrs: {
      "title": "Verify your phone number"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('form', {
    staticClass: "flex-ns flex-wrap",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb3 flex-grow mh3-ns"
  }, [_c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n          A verification code was sent to your new phone number\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "f6 b db mb2"
  }, [_vm._v("Verification Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone_verification_code),
      expression: "phone_verification_code"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "phone_verification_code",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone_verification_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone_verification_code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneVerificationErrorMessage),
      expression: "phoneVerificationErrorMessage"
    }],
    staticClass: "f6 red mh3-ns",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n          " + _vm._s(_vm.phoneVerificationErrorMessage) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "disabled": !_vm.canVerifyPhoneCode,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.verifyPhoneVerificationCode.apply(null, arguments)
      }
    }
  }, [_vm._v("Verify\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showPasswordModal) ? _c('ak-modal', {
    attrs: {
      "title": "Update Password"
    },
    on: {
      "close": _vm.resetState
    }
  }, [(_vm.showSuccessResetMessage) ? _c('div', {
    staticClass: "mt2 mb1 flex-grow mh3-ns",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('label', {
    staticClass: "color-theme f6 b db mb2"
  }, [_vm._v("Password successfully reset")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "flex-ns flex-wrap",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt4 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "pass"
    }
  }, [_vm._v("New password")]), _vm._v(" "), ((_vm.showPasswords ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "pass",
      "autocomplete": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.showPasswords ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "pass",
      "autocomplete": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "pass",
      "autocomplete": "",
      "type": _vm.showPasswords ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "confirm_pass"
    }
  }, [_vm._v("Confirm password")]), _vm._v(" "), ((_vm.showPasswords ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "confirm_pass",
      "autocomplete": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirm) ? _vm._i(_vm.confirm, null) > -1 : (_vm.confirm)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirm,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirm = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirm = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirm = $$c
        }
      }
    }
  }) : ((_vm.showPasswords ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "confirm_pass",
      "autocomplete": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.confirm, null)
    },
    on: {
      "change": function($event) {
        _vm.confirm = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "confirm_pass",
      "autocomplete": "",
      "type": _vm.showPasswords ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.confirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb3 pt3 flex-grow mh3-ns flex items-center"
  }, [_c('a', {
    staticClass: "underline pointer color-theme",
    attrs: {
      "rel": "noopener noreferrer"
    },
    on: {
      "click": function($event) {
        _vm.showPasswords = !_vm.showPasswords
      }
    }
  }, [_vm._v(_vm._s(_vm.showPasswords ? 'Hide' : 'Show'))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordsMatch),
      expression: "passwordsMatch"
    }],
    staticClass: "f6 red mh3-ns mb4",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n      " + _vm._s(_vm.passwordsMatch) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatePassword.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showCreditCardModal) ? _c('ak-modal', {
    attrs: {
      "onMount": _vm.initStripe,
      "title": "Update Credit Card"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb2"
  }, [_c('div', {
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "red f7 mt2",
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "f6 silver mv2"
  }, [_vm._v("All major credit cards accepted")]), _vm._v(" "), _c('svg', {
    attrs: {
      "height": "26px",
      "width": "119px",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M113.000,26.000 L6.000,26.000 C2.686,26.000 0.000,23.314 0.000,20.000 L0.000,6.000 C0.000,2.686 2.686,-0.000 6.000,-0.000 L113.000,-0.000 C116.314,-0.000 119.000,2.686 119.000,6.000 L119.000,20.000 C119.000,23.314 116.314,26.000 113.000,26.000 ZM11.128,8.892 L8.571,8.892 L8.571,16.133 L9.918,16.133 L9.918,13.533 L11.128,13.533 C12.602,13.533 13.654,12.586 13.654,11.218 C13.654,9.850 12.602,8.892 11.128,8.892 ZM17.043,10.745 C15.454,10.745 14.328,11.881 14.328,13.502 C14.328,15.112 15.454,16.259 17.043,16.259 C18.632,16.259 19.748,15.112 19.748,13.502 C19.748,11.881 18.632,10.745 17.043,10.745 ZM26.936,10.871 L25.873,14.449 L24.810,10.871 L23.590,10.871 L22.527,14.449 L21.464,10.871 L20.117,10.871 L21.927,16.133 L23.137,16.133 L24.200,12.555 L25.274,16.133 L26.484,16.133 L28.283,10.871 L26.936,10.871 ZM31.252,10.745 C29.747,10.745 28.653,11.871 28.653,13.460 C28.653,15.101 29.768,16.259 31.357,16.259 C31.946,16.259 32.546,16.122 33.146,15.849 L33.146,14.722 C32.599,15.038 32.062,15.217 31.578,15.217 C30.694,15.217 30.063,14.670 29.978,13.870 L33.546,13.870 C33.567,13.691 33.567,13.523 33.567,13.375 C33.567,11.829 32.630,10.745 31.252,10.745 ZM37.724,10.797 C37.577,10.755 37.430,10.745 37.282,10.745 C36.830,10.745 36.367,10.976 35.988,11.397 L35.988,10.871 L34.641,10.871 L34.641,16.133 L35.988,16.133 L35.988,12.618 C36.335,12.176 36.809,11.934 37.251,11.934 C37.409,11.934 37.577,11.955 37.724,11.997 L37.724,10.797 ZM40.808,10.745 C39.303,10.745 38.209,11.871 38.209,13.460 C38.209,15.101 39.325,16.259 40.914,16.259 C41.503,16.259 42.103,16.122 42.703,15.849 L42.703,14.722 C42.155,15.038 41.619,15.217 41.134,15.217 C40.251,15.217 39.619,14.670 39.535,13.870 L43.102,13.870 C43.123,13.691 43.123,13.523 43.123,13.375 C43.123,11.829 42.187,10.745 40.808,10.745 ZM48.912,8.566 L47.554,8.566 L47.554,11.229 C47.144,10.913 46.681,10.745 46.218,10.745 C44.818,10.745 43.840,11.881 43.840,13.502 C43.840,15.122 44.818,16.259 46.218,16.259 C46.681,16.259 47.144,16.091 47.554,15.764 L47.554,16.133 L48.912,16.133 L48.912,8.566 ZM55.690,10.745 C55.238,10.745 54.775,10.913 54.354,11.229 L54.354,8.566 L53.007,8.566 L53.007,16.133 L54.354,16.133 L54.354,15.764 C54.775,16.091 55.238,16.259 55.690,16.259 C57.100,16.259 58.068,15.122 58.068,13.502 C58.068,11.881 57.100,10.745 55.690,10.745 ZM62.310,10.871 L61.037,14.323 L59.774,10.871 L58.395,10.871 L60.405,15.943 L59.395,18.437 L60.700,18.437 L63.689,10.871 L62.310,10.871 ZM73.109,10.288 C73.972,10.288 75.069,10.552 75.933,11.019 L75.933,8.344 C74.992,7.969 74.052,7.825 73.111,7.825 C70.808,7.825 69.273,9.028 69.273,11.038 C69.273,14.181 73.589,13.671 73.589,15.026 C73.589,15.551 73.133,15.721 72.500,15.721 C71.559,15.721 70.345,15.332 69.392,14.814 L69.392,17.525 C70.448,17.979 71.518,18.169 72.497,18.169 C74.858,18.169 76.485,17.003 76.485,14.959 C76.485,11.573 72.144,12.181 72.144,10.903 C72.144,10.460 72.514,10.288 73.109,10.288 ZM82.180,8.014 L80.024,8.014 L80.022,5.548 L77.250,6.138 L77.237,15.247 C77.237,16.928 78.502,18.169 80.187,18.169 C81.115,18.169 81.801,18.001 82.179,17.793 L82.179,15.482 C81.816,15.627 80.024,16.148 80.024,14.475 L80.024,10.435 L82.180,10.435 L82.180,8.014 ZM88.275,8.015 C87.897,7.879 86.570,7.631 85.905,8.853 L85.727,8.014 L83.272,8.014 L83.272,17.966 L86.110,17.966 L86.110,11.219 C86.781,10.338 87.914,10.508 88.275,10.625 L88.275,8.015 ZM91.999,4.230 L89.149,4.836 L89.149,7.149 L91.999,6.543 L91.999,4.230 ZM91.999,8.014 L89.149,8.014 L89.149,17.966 L91.999,17.966 L91.999,8.014 ZM98.125,7.825 C97.012,7.825 96.293,8.349 95.901,8.715 L95.753,8.014 L93.253,8.014 L93.254,21.268 L96.093,20.664 L96.099,17.451 C96.507,17.750 97.114,18.169 98.108,18.169 C100.139,18.169 101.997,16.535 101.997,12.927 C101.997,9.621 100.119,7.825 98.125,7.825 ZM107.049,7.825 C104.348,7.825 102.704,10.121 102.704,13.013 C102.704,16.437 104.642,18.169 107.408,18.169 C108.765,18.169 109.784,17.861 110.555,17.433 L110.555,15.146 C109.781,15.536 108.893,15.774 107.766,15.774 C106.659,15.774 105.684,15.382 105.557,14.051 L111.116,14.051 C111.129,13.898 111.154,13.303 111.154,13.028 C111.154,10.120 109.746,7.825 107.049,7.825 ZM107.031,10.140 C107.728,10.140 108.468,10.677 108.468,11.955 L105.532,11.955 C105.532,10.676 106.321,10.140 107.031,10.140 ZM97.446,15.661 C96.780,15.661 96.383,15.421 96.107,15.122 L96.090,10.903 C96.386,10.578 96.795,10.340 97.446,10.340 C98.485,10.340 99.200,11.504 99.200,12.989 C99.200,14.518 98.496,15.661 97.446,15.661 ZM55.406,15.101 C55.038,15.101 54.669,14.943 54.354,14.628 L54.354,12.376 C54.669,12.060 55.038,11.902 55.406,11.902 C56.164,11.902 56.690,12.555 56.690,13.502 C56.690,14.449 56.164,15.101 55.406,15.101 ZM46.513,15.101 C45.744,15.101 45.218,14.449 45.218,13.502 C45.218,12.555 45.744,11.902 46.513,11.902 C46.881,11.902 47.249,12.060 47.554,12.376 L47.554,14.628 C47.249,14.943 46.881,15.101 46.513,15.101 ZM40.756,11.786 C41.355,11.786 41.787,12.281 41.829,12.997 L39.535,12.997 C39.598,12.271 40.103,11.786 40.756,11.786 ZM31.199,11.786 C31.799,11.786 32.231,12.281 32.273,12.997 L29.978,12.997 C30.042,12.271 30.547,11.786 31.199,11.786 ZM17.043,15.133 C16.254,15.133 15.707,14.470 15.707,13.502 C15.707,12.534 16.254,11.871 17.043,11.871 C17.822,11.871 18.369,12.534 18.369,13.502 C18.369,14.470 17.822,15.133 17.043,15.133 ZM10.939,12.439 L9.918,12.439 L9.918,9.987 L10.939,9.987 C11.718,9.987 12.265,10.482 12.265,11.218 C12.265,11.944 11.718,12.439 10.939,12.439 Z",
      "fill": "rgb(66, 71, 112)",
      "fill-rule": "evenodd",
      "opacity": "0.502"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeCreditCard.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showShareReferralCodeModal) ? _c('ak-modal', {
    attrs: {
      "title": "Share AKKO with your friends and family!"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb2"
  }, [_c('div', {}, [(!_vm.showEditReferralCodeModal) ? _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n            My code: "), _c('strong', [_vm._v(_vm._s(_vm.user.referral_code))]), _vm._v(" "), _c('a', {
    staticClass: "color-theme underline pointer",
    on: {
      "click": function($event) {
        _vm.showEditReferralCodeModal = true
      }
    }
  }, [_vm._v("Edit")])]) : _vm._e(), _vm._v(" "), (!_vm.showEditReferralCodeModal) ? _c('div', {
    staticClass: "mv4 lh-copy"
  }, [_vm._v("\n            Anyone who uses your code will get their 1st month FREE and you'll get a $20 credit towards your\n            deductibles\n            on any future claims you have! You get a $20 credit per referral, with no limit on how much credit you can\n            stack up.\n          ")]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referralCode),
      expression: "referralCode"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    domProps: {
      "value": (_vm.referralCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referralCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.$store.state.errors.length && _vm.showEditReferralCodeModal) ? _c('div', {
    staticClass: "red f7 mt2"
  }, [_vm._v("This referral code is not\n        available\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mb3",
    staticStyle: {
      "height": "10px"
    }
  }, [(_vm.copyPressed) ? _c('div', [_vm._v("\n          Copied!\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.showEditReferralCodeModal) ? _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEditReferralCodeModal = false
      }
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateReferralCode.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")])], 1)]) : _c('div', {
    staticClass: "pa3 flex flex-wrap justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.isMobile) ? _c('div', {
    staticClass: "ma2 flex-grow flex-grow-off-ns"
  }, [_c('ak-share-button', {
    attrs: {
      "description": _vm.shareBody,
      "networkName": "sms",
      "title": "Message (SMS)"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ma2 flex-grow flex-grow-off-ns"
  }, [_c('a', {
    staticClass: "white no-underline bg-theme pv3 ph4 br-pill pointer ba bw1 db b-theme flex-grow flex-grow-off-ns",
    attrs: {
      "href": _vm.emailPath
    }
  }, [_vm._v("Email")])]), _vm._v(" "), _c('div', {
    staticClass: "ma2 flex-grow flex-grow-off-ns"
  }, [_c('ak-share-button', {
    attrs: {
      "description": ("I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out! " + _vm.shareBody),
      "networkName": "facebook",
      "title": "Facebook"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ma2 flex-grow flex-grow-off-ns"
  }, [_c('ak-share-button', {
    attrs: {
      "description": _vm.shareBody,
      "postTitle": ("I just signed up with AKKO to protect my phone and all electronics for only $15/mo. Check it out! " + _vm.shareBody),
      "networkName": "twitter",
      "title": "Twitter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ma2 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.referralCode),
      expression: "referralCode",
      arg: "copy"
    }],
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyReferralCode.apply(null, arguments)
      }
    }
  }, [_vm._v("Copy")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mr3 ma2 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5981b36d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountPage.vue
// module id = 1503
// module chunks = 0